import React from 'react'

const RequesterNotification = () => {
  return (
    <div>RequesterNotification</div>
  )
}

export default RequesterNotification